var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.2 47.6",
    style: {
      enableBackground: "new 0 0 39.2 47.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5,20.1h-2.1c-0.2,0-0.4-0.2-0.4-0.4v-4.4c0-7.8-5.9-14.4-13.7-14.8C12,0.1,5.2,6.7,5.2,14.9v4.8c0,0.2-0.2,0.4-0.4,0.4 H2.7c-1.5,0-2.7,1.2-2.7,2.7v1.7c0,0.3,0.3,0.6,0.6,0.6h6.1c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5H0.6c-0.3,0-0.6,0.3-0.6,0.6v3 c0,0.3,0.3,0.6,0.6,0.6h6.1c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5H0.6c-0.3,0-0.6,0.3-0.6,0.6v3c0,0.3,0.3,0.6,0.6,0.6h6.1 c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5H0.6c-0.3,0-0.6,0.3-0.6,0.6v1.8c0,1.5,1.2,2.7,2.7,2.7h33.8c1.5,0,2.7-1.2,2.7-2.7v-22 C39.2,21.3,38,20.1,36.5,20.1z M29.2,19.7c0,0.2-0.2,0.4-0.4,0.4H10.4c-0.2,0-0.4-0.2-0.4-0.4v-4.5c0-5.1,3.8-9.5,8.9-9.9 c5.6-0.4,10.2,4,10.2,9.5L29.2,19.7L29.2,19.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.fd26f6a02ec5722d52e8b2f0a218b39f.svg";
export { ForwardRef as ReactComponent };